:host {
  display: block;
}
apie-exception-display, apie-stack-display {
  margin: 1em;
}